import { gql } from '@apollo/client';

export const QUERY_ALL_COMMS = gql`
    query GetAllCommunications {
        email_communications(order_by: { event: asc }) {
            communication_id
            description
            entity
            event
            name
            type
        }
    }
`;

export const QUERY_CLIENT_EMAIL_SUBSCRIPTIONS = gql`
    query ClientEmailSubscriptions($client_id: uuid!) {
        clients_by_pk(client_id: $client_id) {
            client_id
            email_subscriptions {
                client_id
                communication_id
                email
            }
        }
    }
`;

// update_columns is empty because every column is part of the key — nothing to overwrite.
export const ADD_EMAILS_TO_SUBSCRIPTION = gql`
    mutation AddEmailsToSubscription($objects: [email_subscriptions_insert_input!]!) {
        insert_email_subscriptions(
            objects: $objects
            on_conflict: { constraint: email_subscriptions_pkey, update_columns: [] }
        ) {
            returning {
                client_id
                communication_id
                email
            }
        }
    }
`;

// Hasura runs multiple root fields in one transaction, so the delete and insert land atomically.
// Both no-op safely when empty: `_in: []` matches nothing, `objects: []` inserts nothing.
export const SYNC_EMAIL_COMMUNICATIONS = gql`
    mutation SyncEmailCommunications(
        $client_id: uuid!
        $email: String!
        $remove: [uuid!]!
        $add: [email_subscriptions_insert_input!]!
    ) {
        delete_email_subscriptions(
            where: { client_id: { _eq: $client_id }, email: { _eq: $email }, communication_id: { _in: $remove } }
        ) {
            affected_rows
        }
        insert_email_subscriptions(
            objects: $add
            on_conflict: { constraint: email_subscriptions_pkey, update_columns: [] }
        ) {
            returning {
                client_id
                communication_id
                email
            }
        }
    }
`;

export const DELETE_ALL_FOR_EMAIL = gql`
    mutation DeleteAllForEmail($client_id: uuid!, $email: String!) {
        delete_email_subscriptions(where: { client_id: { _eq: $client_id }, email: { _eq: $email } }) {
            affected_rows
        }
    }
`;
